const extractFullName = (data: { firstName?: string; lastName?: string }): string =>
  data && data.firstName && data.lastName ? `${data.firstName} ${data.lastName}` : '';

export default extractFullName;
